import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-rent-income-return-v2',
    templateUrl: './rent-income-return-v2.component.html',
    styleUrls: ['./rent-income-return-v2.component.css'],
    standalone: false
})
export class RentIncomeReturnV2Component implements OnInit, OnChanges{

  constructor() { }

  @Input() returnData
  @Input() printActive:boolean

  data:any
  greaterOfRentAndAnnual: number
  totalRentValue: number
  rentIncomeAvailable: boolean = false
  netIncomeFromRent: number
  advanceAdjustmentAmount: number
  advanceRentReceived: number
  valueOfAnyBenefit: number
  totalRentalIncome: number
  otherIncome: number
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.returnData?.headSummery?.rentDetailsSummery?.housePropertySummeryDetails

    this.advanceRentReceived = 0   ///Will be zero for now
    if((this.data?.annualAmount ?? 0) > ((this.data?.rentAmount ?? 0) + (this.data?.advanceAdjustmentAmount ?? 0))){
      this.advanceAdjustmentAmount = 0
    }
    else{
      this.advanceAdjustmentAmount = (this.data?.advanceAdjustmentAmount ?? 0)
    }

    this.valueOfAnyBenefit = (this.data?.anyOtherAmount ?? 0) + (this.data?.advanceRentReceived ?? 0)
    // this.greaterOfRentAndAnnual = (this.data?.annualAmount ?? 0) > (this.data?.rentAmount ?? 0) ? this.data?.annualAmount : this.data?.rentAmount
    this.greaterOfRentAndAnnual = (this.data?.annualAmount ?? 0) > ((this.data?.rentAmount ?? 0) + (this.data?.advanceAdjustmentAmount ?? 0)) ? this.data?.annualAmount : this.data?.rentAmount
    this.totalRentValue = (this.greaterOfRentAndAnnual ?? 0) + (this.data?.advanceRentReceived ?? 0) + (this.data?.anyOtherAmount ?? 0) + (this.advanceAdjustmentAmount ?? 0) - (this.data?.vacancyAllowanceAmount ?? 0)
    this.netIncomeFromRent = this.totalRentValue - (this.data?.allowableDeduction ?? 0)
    
    this.rentIncomeAvailable = this.returnData?.headSummery?.incomeHeadsList?.filter((item)=>item === 'Income from Rent')[0] ? true : false;
    this.totalRentalIncome = (this.netIncomeFromRent ?? 0) + (this.data?.specialRentalIncome ?? 0);
    this.otherIncome = (this.data?.other ?? 0) + (this.data?.preRentalInterestOnLoanMortgageCapital ?? 0);
  }

}
